/** Fingerprint server/page metadata so geometry changes retrigger pdf.js measurement. */
export function fingerprintPageSizes(
  pageSizes: ReadonlyArray<{ width: number; height: number; rotation?: number }>
): string {
  return pageSizes
    .map((s) => `${Math.round(s.width)}x${Math.round(s.height)}@${s.rotation ?? 0}`)
    .join('|');
}

let measurementGeneration = 0;
let lastAcceptedSyncGeneration = 0;

/** Start a new pdf.js measurement pass for the open file. */
export function beginPageSizeMeasurement(): number {
  return ++measurementGeneration;
}

/**
 * Invalidate viewport syncs from prior document bytes (page rotate/merge/reorder).
 * Only measurements with generation > this point are accepted.
 */
export function invalidatePageSizeSync(): void {
  lastAcceptedSyncGeneration = measurementGeneration;
}

/** True when a viewport sync belongs to the current document generation. */
export function shouldAcceptPageSizeSync(epoch: number): boolean {
  return epoch > lastAcceptedSyncGeneration;
}

export function markPageSizeSyncAccepted(epoch: number): void {
  if (epoch > lastAcceptedSyncGeneration) {
    lastAcceptedSyncGeneration = epoch;
  }
}